module.exports = __webpack_public_path__ + "media/images/pic02-63324749d1befd127a9887c4d02dbc06.jpg";